var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"analysis-menu"},[_c('ul',{staticClass:"analysis-menu__list"},_vm._l((_vm.list),function(ref,index){
var link = ref.link;
var text = ref.text;
return _c('li',{key:index,class:[_vm.currentClass(link), link ? 'menu-list' : 'menu-label']},[_c('a',{attrs:{"href":("/analysis/" + link + "/")}},[_vm._v(_vm._s(text))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }